var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-popconfirm',{attrs:{"title":_vm.title},on:{"onConfirm":_vm.confirm}},[_c('el-button',{attrs:{"slot":"reference","type":_vm.type},slot:"reference"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }